import React from "react";
import VideoTestimonialCarousel from "@/components/ui/video-testimonial-carousel";
import { VideoTestimonialProps } from "@/components/ui/video-testimonial";
import { TESTIMONIALS_FROM_PROFESSIONALS_TESTIMONIALS } from "@/lib/data";
import GreatPlaceToWorkLogo from "@/assets/images/social-proof/testimonials-professionals/logos/GPTW.png";
import SanFranciscoChronicleLogo from "@/assets/images/social-proof/testimonials-professionals/logos/SFC.png";
import FortuneBestWorkplacesLogo from "@/assets/images/social-proof/testimonials-professionals/logos/Fortune.png";
import BestOfHomeCareOfChoice2022Logo from "@/assets/images/social-proof/testimonials-professionals/logos/EOC 2022.png";
import BestOfHomeCareOfChoice2024Logo from "@/assets/images/social-proof/testimonials-professionals/logos/EOC 2024.png";
import Image from "next/image";

export interface TestimonialsProfessionalsProps {
  id?: string;
  heading?: string;
  slides?: VideoTestimonialProps[];
  showLogos?: boolean;
}

const TestimonialsProfessionals: React.FC<TestimonialsProfessionalsProps> = ({
  id = "testimonials-professionals",
  heading = "Testimonials from Professionals",
  slides = TESTIMONIALS_FROM_PROFESSIONALS_TESTIMONIALS,
  showLogos = true,
}) => {
  return (
    <section
      className="bg-white"
      id={id}
    >
      <div className="flex w-full flex-col gap-4 p-4 md:gap-6 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:gap-8 lg:px-3 lg:py-10">
        <h2 className="mx-auto text-center font-montserrat text-heading-4 text-neutral-600 md:text-heading-3 lg:text-heading-2">
          {heading}
        </h2>
        {showLogos && (
          <div className="mx-auto flex h-8 w-full flex-row md:h-18 md:gap-10 md:px-24 lg:h-24 lg:justify-between lg:overflow-hidden lg:px-52">
            <Image
              className="size-full object-contain"
              src={GreatPlaceToWorkLogo}
              quality={100}
              alt="Great Place to Work logo"
            />
            <Image
              className="size-full object-contain"
              src={SanFranciscoChronicleLogo}
              quality={100}
              alt="San Francisco Chronicle logo"
            />
            <Image
              className="size-full object-contain"
              src={FortuneBestWorkplacesLogo}
              quality={100}
              alt="Fortune Best Workplaces logo"
            />
            <Image
              className="size-full object-contain"
              src={BestOfHomeCareOfChoice2022Logo}
              quality={100}
              alt="Best of Home Care of Choice 2022 logo"
            />
            <Image
              className="size-full object-contain"
              src={BestOfHomeCareOfChoice2024Logo}
              quality={100}
              alt="Best of Home Care of Choice 2024 logo"
            />
          </div>
        )}
        <div className="flex">
          <VideoTestimonialCarousel slides={slides} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsProfessionals;
